export const VERTEX = /* glsl */ `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;
export const FRAGMENT = /* glsl */ `
  uniform float uTime;
  uniform float uScrollSpeed;
  uniform vec3 uFoamColor;
  uniform vec3 uBodyColor;
  uniform float uStripeFrequency;
  varying vec2 vUv;
  void main() {
    float scrolledV = vUv.y - uTime * uScrollSpeed;
    float stripe = 0.5 + 0.5 * sin(scrolledV * uStripeFrequency * 6.28318);
    float topFoam = smoothstep(0.85, 1.0, vUv.y);
    float bottomFoam = smoothstep(0.85, 1.0, 1.0 - vUv.y);
    float foamMask = max(topFoam, bottomFoam);
    vec3 color = mix(uBodyColor, uFoamColor, max(stripe * 0.4, foamMask));
    float edgeAlpha = smoothstep(0.0, 0.05, vUv.x) * smoothstep(0.0, 0.05, 1.0 - vUv.x);
    gl_FragColor = vec4(color, edgeAlpha * 0.9);
  }
`;
